<template>
    <div>
        <v-col class="pa-0" cols="12" :style="offset">
            <template>
                <v-card
                    class="mx-auto"
                    tile
                    :style="offset"  
                    elevation="0"
                    :color="cardColor"    
                >
                    <v-list-item class="comment-content">
                        <v-avatar :color="item.color" class="mr-3 avatar" size="30" left>
                            <span class="white--text text-h5">{{ item.initials }}</span>
                        </v-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold mb-1">{{ item.user }}</v-list-item-title>
                            <div class="overline mb-4">{{ item.created_at }}</div>
                            <div class="text--primary comment-text" v-html="item.comment"></div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-divider></v-divider>
            </template>
        </v-col>
    </div>
</template>

<script>
const COLORS = [
    'white',
    'grey lighten-5',
    'grey lighten-4',
    'grey lighten-3',
    'grey lighten-2',
];

export default {
    // MUST give a name in recursive components
    // https://vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
    name: 'Comment',

    props: {
        item: {type: Object, required: true},
        depth: {type: Number, default: 0},
    },

    data() {
        return {
            childrenCount: 0,
            voptions: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": false, "fullscreen": false, "keyboard": false, "url": "data-source" }
        };
    },

    computed: {
        direct() {
            if (Array.isArray(this.item.children)) {
                return this.item.children.length;
            }

            return 0;
        },

        offset() {
            return {
                'padding-left': (this.depth * 20) + 'px'
            };
        },

        cardColor() {
            return COLORS[this.depth % COLORS.length]
        },
    },

    mounted() {
        this.$emit('born');
    },

    methods: {
        handleBorn() {
            this.childrenCount++;
            this.$emit('born');
        },
    },
};
</script>

<style lang="sass" scoped>
.comment-actions
    padding-left: 50px

.comment-content 
    align-items: flex-start

.avatar 
    margin-top: 15px
</style>